import React from "react";
import "./Footer.css";
import FooterCol from "./FooterCol";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";

const Footer = () => {
  const noNamed = [
    { name: "Web Application", link: "/emergency" },
    { name: "Development", link: "/checkup" },
    { name: "Technology", link: "/personal-treatment" },
    { name: "React", link: "/extract" },
    { name: "Eduation", link: "/checkupCode" },
    { name: "Projects", link: "/checkupApp" },
    { name: "Javascript", link: "/checkupUpdate" },
  ];
  const ourAddress = [
    { name: "Get In touch", link: "/" },
    { name: "", link: "//google.com/map" },
  ];

  const services = [
    { name: "Website Development", link: "/contact" },
    { name: "Building Applications", link: "/contact" },
    { name: "SEO & Digital Marketing", link: "/digitalMarketing" },
    { name: "Branding and Identity", link: "/Branding" },
    { name: "Mentoring In Bangla", link: "/Contact" },
  ];
  return (
    <footer className="footer-area text-white clear-both">
      <div className="container pt-5">
        <div className="row py-5">
          <FooterCol key={1} menuTitle={"Popular Tags"} menuItems={noNamed} />
          <FooterCol key={2} menuTitle="Services" menuItems={services} />
          <FooterCol key={4} menuTitle="" menuItems={ourAddress}>
            <ul className="social-media list-inline">
              <li className="list-inline-item">
                <a
                  title=" Linkedin"
                  target="_blank"
                  rel="noreferrer"
                  className="Footer_Link_style"
                  href="https://www.linkedin.com/in/azimuahamed/"
                >
                  <i
                    className="mx-2 fa fa-linkedin"
                    style={{
                      fontSize: "36px",
                      color: "white",
                    }}
                  ></i>
                </a>
              </li>
              <li className="list-inline-item">
                <a
                  title=" twitter"
                  target="_blank"
                  rel="noreferrer"
                  className="Footer_Link_style"
                  href="https://twitter.com/AzimAhm81832848"
                >
                  <i
                    className="mx-2 fa fa-twitter"
                    style={{
                      fontSize: "36px",

                      color: "white",
                    }}
                  ></i>
                </a>
              </li>

              <li className="list-inline-item">
                <a
                  title="github"
                  target="_blank"
                  rel="noreferrer"
                  className="Footer_Link_style"
                  href="https://github.com/Azim-Ahmed"
                >
                  <i
                    className="mx-2 fa fa-github"
                    style={{
                      fontSize: "36px",
                      color: "white",
                    }}
                  ></i>
                </a>
              </li>

              <li className="list-inline-item">
                <a
                  title=" facebook"
                  target="_blank"
                  rel="noreferrer"
                  className="Footer_Link_style"
                  href="https://www.linkedin.com/in/azimuahamed/"
                >
                  <i
                    className="mx-2 fa fa-facebook-f"
                    style={{
                      fontSize: "36px",
                      color: "white",
                    }}
                  ></i>
                </a>
              </li>
              <li className="list-inline-item">
                <a
                  title=" Medium"
                  target="_blank"
                  rel="noreferrer"
                  className="Footer_Link_style"
                  href="https://azimuahamed.medium.com/"
                >
                  <i
                    className="mx-2 fa fa-medium"
                    style={{
                      fontSize: "36px",
                      color: "white",
                    }}
                  ></i>
                </a>
              </li>
            </ul>
            <div className="mt-5">
              <h6 className="text-white">Feel free to call</h6>
              <button className="text-white btn btn-brand">
                +8801966478542
              </button>
              <Link to="/contact">
                <Button outline color="danger">
                  Send A Message
                </Button>
              </Link>
            </div>
          </FooterCol>
        </div>
        <div className="copyRight text-center">
          <p className="text-white mb-0 pb-2">
            © Azim Uddin Ahamed &nbsp;
            {new Date().getFullYear()}
            Chandpur, Bangladesh
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
